import { init as initHomeClients } from "./home-clients";
import { init as initNosotros } from "./nosotros";

/**
 * Inicializa todos los Swipers.
 * Se llama en la carga inicial y tras cada transición de Barba.
 */
export function initAllSwipers() {
  initHomeClients();
  //initNosotros();
}

document.addEventListener("DOMContentLoaded", () => {
  initAllSwipers();
});
